/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './mobile_client_source_details';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "data": {
            "nested": {
              "SourceDetails": {
                "fields": {
                  "mobileClientSourceDetails": {
                    "type": ".squareup.addons.data.MobileClientSourceDetails",
                    "id": 1
                  }
                },
                "nested": {
                  "source_details": {
                    "oneof": ["mobileClientSourceDetails"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.SourceDetails) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SourceDetails @ squareup/addons/data/source_details.proto at 10:1
 */
export const SourceDetails = $root.lookupType('squareup.addons.data.SourceDetails');
fixType(SourceDetails);
Builder.createAndAttachToType(SourceDetails);